export const durationIso8601ToMinute = (duration: string) =>
  Number(duration?.slice(duration.indexOf('H') + 1, duration.indexOf('M')));
